export default "__VITE_ASSET__DvGe7H6v__"